import React, { useEffect } from 'react'
import useReactRouter from 'use-react-router'
import { Table, Popconfirm, Layout, PageHeader } from 'antd'
import notification from 'mrx-notification'
import { ColumnsType } from 'antd/lib/table'
import { Breadcrumbs } from 'components'
import * as rootStyles from 'assets/layoutStyle'
import styles from './ZipwhipSettingsList.module.scss'
import { connector, PropsFromRedux } from './container'
import { ZipwhipSetting } from '../../types'
import CreateZipwhipSetting from '../CreateZipwhipSetting'

const ZipwhipSettingsList = (props: PropsFromRedux) => {
  const {
    zipwhipSettingsList,
    isLoading,
    error,
    isNeedToFetchList,
    total,
    currentPage,

    removeZipwhipSetting,
    fetchZipwhipSettingsList,
    changeCurrentPage
  } = props

  const { history } = useReactRouter()

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Zipwhip settings list page error!',
        description: error
      })
    }
  }, [error])

  useEffect(() => {
    isNeedToFetchList && fetchZipwhipSettingsList()
  }, [fetchZipwhipSettingsList, isNeedToFetchList])

  const doConfirm = async (zipwhipSettingId: number, e?: React.MouseEvent<HTMLElement>) => {
    e && e.stopPropagation()
    const isRemoved = await removeZipwhipSetting(zipwhipSettingId)
    if (isRemoved) {
      notification.success({
        message: 'Successfully',
        description: 'Zipwhip setting was deleted successfully!'
      })
    }
  }

  const columns: ColumnsType<ZipwhipSetting> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username'
    },
    {
      title: 'Password',
      dataIndex: 'password',
      key: 'password'
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      render: (record: ZipwhipSetting) => (
        <span>
          <Popconfirm
            title='Are you sure delete this setting?'
            onConfirm={(e) => doConfirm(record.id, e)}
            onCancel={(e) => e?.stopPropagation()}
            okText='Yes'
            cancelText='No'
          >
            <a
              href='/#'
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              Remove
            </a>
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Layout className={styles.root}>
      <Layout.Header style={rootStyles.header}>
        <PageHeader onBack={() => history.goBack()} title='Zipwhip Settings List' extra={[<CreateZipwhipSetting key='1' />]} />
      </Layout.Header>
      <Layout.Content style={rootStyles.contentBreadcrumbs}>
        <Breadcrumbs
          items={[
            { title: 'Main', url: '/' },
            { title: 'Settings', url: '/' },
            { title: 'Plugins', url: '' },
            { title: 'Zipwhip Settings', url: '/settings/plugins' }
          ]}
        />
      </Layout.Content>
      <Layout.Content className={styles.contentComponent}>
        <Table
          columns={columns}
          dataSource={zipwhipSettingsList}
          bordered
          rowKey={(record) => record.id}
          loading={isLoading}
          pagination={{
            onChange: changeCurrentPage,
            current: currentPage,
            total
          }}
        />
      </Layout.Content>
    </Layout>
  )
}

export default connector(ZipwhipSettingsList)
